<div class="pc-content" style="background:white; padding: 10px">
    <div class="pc-content-item1">


        <kendo-grid
            #allCategoryItemsGrid
            (dataStateChange)="dataStateChangeInventoryDetails($event)"
            [data]="inventoryGridData"
            [filter]="inventoryState.filter"
            [filterable]="true"
            [kendoGridSelectBy]="removeCallBack"
            [navigable]="true"
            [reorderable]="true"
            [resizable]="true"
            [selectable]="true"
            [selectable]="true"
            [selectedKeys]="inventoryItemSelected"
            [skip]="inventoryState.skip"
            [sortable]="true"
            id="grid-items"
            style="height: 65vh">
            <kendo-grid-column [title]="'Description'" field="description" filterable="true" width="240">
            </kendo-grid-column>
        </kendo-grid>
    </div>
    <div class="pc-content-item2">
        <loadingButton (buttonPressed)="removeBtnClicked()" class="pc-center-buttons" text=" >>> "></loadingButton>
        <loadingButton (buttonPressed)="copyBtnClicked()" class="pc-center-buttons" text=" <<< "></loadingButton>
    </div>
    <div class="pc-content-item3">

        <kendo-grid
            #itemsInGridGrid
            (dataStateChange)="dataStateChangeItemDetails($event)"
            [data]="gridData"
            [filter]="stateItemsTable.filter"
            [filterable]="true"
            [kendoGridSelectBy]="selectedCallback"
            [navigable]="true"
            [reorderable]="true"
            [resizable]="true"
            [selectable]="true"
            [selectedKeys]="orderItemsSelected"
            [skip]="stateItemsTable.skip"
            [sortable]="true"
            id="grid-item"
            style="height: 66vh">
            <kendo-grid-column [title]="'Description'" field="description" filterable="true" width="240">
            </kendo-grid-column>
        </kendo-grid>

        <div class="buttonflex">
            <loadingButton
                    inprogressMessage="Saving"
                    text="Save Items">
            </loadingButton>
        </div>
    </div>
    <!--    <div  class="k-i-loading"></div>-->
    <!--    <mat-progress-bar-->

    <!--            style="position: absolute; top: 0; z-index: 5000;">-->
    <!--    </mat-progress-bar>-->
</div>

